var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-compoment"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v(_vm._s(_vm.hao))])])
}
var staticRenderFns = []

export { render, staticRenderFns }